import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"

import * as PlotSteps from "@fae/source/data/plot/steps.js"
import FirstTimeRollModal from "./modals/FirstTimeRollModal.jsx"
import Unit from "@fae/source/models/Unit.js"

export default function RollPhase() {
    return [
        ClearAllRolls(),
        // FirstTimeRollModal(),

        Step.flag("hud", false),
        (stage) => {
            return Step.deltastage({
                "player": {
                    "phase": "rolling",
                    "zoomout": 0.7,
                    "rollcount": (stage.player.rollcount || 0) + (stage.turn.number >= 2 ? (1 + (window.extraRerolls || 0)) : 0)
                },
            })
        },
        PlotSteps.Wait(800),

        PlotSteps.PlayAudio("Dice:Roll"),
        Roll({"affiliations": ["bad"]}),
        PlotSteps.Wait(1600),

        LockInEnemies(), // FOR SOME REASON, THIS BUGGED WHEN ALSO SETTING THE PLAYER PHASE TO PLAYING AT THE END??
        PlotSteps.Wait(1200),

        // // TODO: only do this when in the  tutorial roll. And use flags, not window!!
        (stage) => {
            if(window.hasRolled != true // TODO: make this tutorial flags
            && stage.currentEncounterKey == 1
            && stage.turn.phase == "start"
            && stage.turn.number == 2) {
                return FirstTimeRollModal()
            }
        },

        PlotSteps.PlayAudio("Dice:Roll"),
        Roll({"affiliations": ["good"]}),
        PlotSteps.Wait(1600),

        Step.deltastage({ // THIS SKIPS THE PLAYER ROLL PHASE`
            "player": {
                "phase": "playing",
                "zoomout": 0.8,
            },
        }),
        Step.flag("hud", true),
        // PlotSteps.PlayStinger("Stinger:PlayerTurn"),
        // PlotSteps.Wait(1200),
    ]
}

RollPhase.ClearAllRolls = ClearAllRolls

function ClearAllRolls() {
    return function(stage) {
        const deltastages = []
        Object.values(stage.units).forEach((unit) => {
            deltastages.push({
                "unit": {
                    "key": unit.key,
                    "equippedItem": null,
                    "power": 0,
                    // "moverange": 2, // TODO: make this a temp effect, not the actual stat. THIS IS BREAKING THE SLIMES
                    // "moverange": unit.jobKey != undefined && unit.jobKey.includes("slime") ? 1 : 2,
                    "armor": 0,
                    "isLockedIn": false,
                }
            })
        })
        return {
            "deltastages": deltastages
        }
    }
}

function Roll({affiliations}) {
    return function(stage) {
        const step = {"deltastages": []}
        affiliations = affiliations ?? ["good", "bad"]

        affiliations.forEach((affiliation) => {
            const units = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.isLockedIn != true
                    && unit.affiliation == affiliation
                    && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
            })
            units.forEach((unit, index) => {
                if(unit.affiliation != affiliation) return
                if(unit.items == undefined) return

                const items = Unit.items({stage, unit})
                let diceFace = stage.random.element(Object.values(items))

                // TODO: wrap these in a tutorial-only mode.
                if(stage.currentEncounterKey == 1) {
                    let diceFaceIndex = (stage.turn.number / 2) % 2 == 0 ? 0 : 2
                    diceFace = items[diceFaceIndex] || diceFace
                }
                if(stage.currentEncounterKey == 2 && stage.turn.number == 0) {
                    diceFace = items[5] || diceFace
                }

                step.deltastages.push({
                    "unit": {
                        "key": unit.key,
                        "equippedItem": diceFace,
                        "rollingIndex": index,
                    }
                })
            })
        })
        return step
    }
}

function LockInEnemies() {
    return function(stage) {
        const step = {"deltastages": []}
        Object.values(stage.units).forEach((unit) => {
            if(unit.affiliation == "bad"
            && unit.isDead != true
            && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)) {
                step.deltastages.push({
                    "unit": {
                        "key": unit.key,
                        "isLockedIn": true,
                    }
                })
            }
        })
        return step
    }
}
